import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as tslib_1 from "tslib";
import { GENERIC_LOGIN_ERROR_MSG, ISSUE_SENDING_TWO_FACTOR_AUTHENTICATION_SECURITY_CODE_ERROR_MSG, ISSUE_SUBMITTING_TWO_FACTOR_AUTHENTICATION_SECURITY_CODE_ERROR_MSG, TB_END_USER_IP_HEADER, TokenRequestUrl, TOO_MANY_REQUESTS_ERROR_MSG } from '../constants';
import CryptoJS from 'crypto-js';
import { TwoFactorAuthenticationEnabledLoginStates } from '@tradingblock/types';

function base64url(source) {
  // Encode in classical base64
  var encodedSource = CryptoJS.enc.Base64.stringify(source); // Remove padding equal characters

  encodedSource = encodedSource.replace(/=+$/, ''); // Replace characters according to base64url specifications

  encodedSource = encodedSource.replace(/\+/g, '-');
  encodedSource = encodedSource.replace(/\//g, '_');
  return encodedSource;
}

function GenerateIV() {
  var date = new Date();
  var ivyear = date.getUTCFullYear().toString();
  var ivmonth = date.getUTCMonth() + 1 > 9 ? (date.getUTCMonth() + 1).toString() : '0' + (date.getUTCMonth() + 1);
  var ivday = date.getUTCDate() > 9 ? date.getUTCDate().toString() : '0' + date.getUTCDate();
  var ivstr = 'TBAPIENT' + ivyear + ivmonth + ivday;
  return ivstr;
} //helper function for encrypt message


function Encrypt(txtUserName, _key) {
  var key = CryptoJS.enc.Utf8.parse(_key);
  var iv = CryptoJS.enc.Utf8.parse(GenerateIV());
  var ciphertext = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(txtUserName), key, {
    keySize: 128,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  var re = String(ciphertext.toString());
  re = re.replace(/=+$/, '');
  re = re.replace(/\+/g, '-');
  re = re.replace(/\//g, '_');
  return re;
} //--------------------------------------------------------------------------------
// STEP 1: generate JWT header this part should provide a static output as: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9"


function generateHeader() {
  var header = {
    typ: 'JWT',
    alg: 'HS256'
  };
  var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  var encodedHeader = base64url(stringifiedHeader);
  return encodedHeader;
} //----------------------------------------------------
//STEP 3: Generate Signature


function generateSignature(_header, _payload, _apikey) {
  var toSign = _header + '.' + _payload;
  var signature = CryptoJS.HmacSHA256(toSign, _apikey);
  var encodedSignature = base64url(signature);
  return encodedSignature;
} //------------------------------------------------------
//STEP 2: generate Payload


function generatePayload(_username, _password, _apikey, _bearer) {
  var user = {
    username: _username,
    password: _password
  }; //encode user

  var stringedUser = JSON.stringify(user); //encode user json and use AES to encrypt with api key.

  var ciphertext = Encrypt(stringedUser, _apikey);
  var date = new Date();
  var payload = {
    EndUser: ciphertext,
    Entity: _bearer,
    Timestamp: date
  };
  var stringifiedPayload = CryptoJS.enc.Utf8.parse(JSON.stringify(payload));
  var encodedPayload = base64url(stringifiedPayload);
  return encodedPayload;
}

function getTokenRequest(username, password, apikey, bearer) {
  var header = generateHeader();
  var payload = generatePayload(username, password, apikey, bearer);
  var signature = generateSignature(header, payload, apikey);
  var request = header + '.' + payload + '.' + signature;
  return request;
}

export function GetToken(api) {
  var _this = this;

  return function (username, password, key, bearer, queryParams, twoFactorAuthenticationEnabledLoginState,
  /** When present, sent to RestHub on `Auth/token` as `CF-Connecting-IP` for login-history attribution.
   * If RestHub responds with HTTP 403 (some environments reject this header on server-to-server calls),
   * we retry once without it. */
  endUserClientIp) {
    var request = getTokenRequest(username, password, key, bearer);
    console.log('[getToken] token request JWS length', request.length);
    var trimmedEndUserIp = endUserClientIp != null && String(endUserClientIp).trim() !== '' ? String(endUserClientIp).trim() : undefined;
    var postOptsWithAudit = trimmedEndUserIp != null ? {
      queryParams: queryParams,
      headers: _defineProperty({}, TB_END_USER_IP_HEADER, trimmedEndUserIp)
    } : {
      queryParams: queryParams
    };
    var postOptsNoAudit = {
      queryParams: queryParams
    };

    var runPost = function runPost(opts) {
      return api.post(TokenRequestUrl, {
        JWS: request
      }, opts);
    };

    var execute = function execute() {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var maybeAxios, status;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!trimmedEndUserIp) {
                  _context.next = 18;
                  break;
                }

                console.log('[getToken] RestHub login audit header', {
                  headerName: TB_END_USER_IP_HEADER,
                  endUserClientIp: trimmedEndUserIp
                });
                _context.prev = 2;
                _context.next = 5;
                return runPost(postOptsWithAudit);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                maybeAxios = _context.t0;
                status = maybeAxios.response != null ? maybeAxios.response.status : undefined;

                if (!(status === 403)) {
                  _context.next = 17;
                  break;
                }

                console.warn('[getToken] Auth/token returned HTTP 403 with CF-Connecting-IP; retrying without end-user IP header', {
                  endUserClientIp: trimmedEndUserIp
                });
                _context.next = 16;
                return runPost(postOptsNoAudit);

              case 16:
                return _context.abrupt("return", _context.sent);

              case 17:
                throw _context.t0;

              case 18:
                console.warn('[getToken] no endUserClientIp; RestHub will see apiserver TCP peer only');
                _context.next = 21;
                return runPost(postOptsNoAudit);

              case 21:
                return _context.abrupt("return", _context.sent);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 8]]);
      }));
    };

    return execute().then(function (res) {
      if (res && res.responseCode !== 0) {
        console.log('GetToken Response:', res);
      }

      return res;
    }).catch(function (error) {
      console.error('GetToken Error:', error.message || error);
      var status = error && error.response && error.response.status;

      if (status === 429) {
        throw new Error(TOO_MANY_REQUESTS_ERROR_MSG);
      }

      if (twoFactorAuthenticationEnabledLoginState === TwoFactorAuthenticationEnabledLoginStates.RequestSecurityCode) {
        throw new Error(ISSUE_SENDING_TWO_FACTOR_AUTHENTICATION_SECURITY_CODE_ERROR_MSG);
      } else if (twoFactorAuthenticationEnabledLoginState === TwoFactorAuthenticationEnabledLoginStates.SubmitSecurityCode) {
        throw new Error(ISSUE_SUBMITTING_TWO_FACTOR_AUTHENTICATION_SECURITY_CODE_ERROR_MSG);
      }

      throw new Error(GENERIC_LOGIN_ERROR_MSG);
    });
  };
}